<div mat-dialog-title>
  <div style="padding-left: 15px; display: inline;">
    {{ modalData.title }}
  </div>
  <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()" style="float: right; margin-top: -6px;">
    <img src="../../../../assets/close-white.png" style="width: 12px;">
  </button>
</div>

<mat-dialog-content *ngIf="!pollData" id="lifedi-modal" class="mat-typography pb-4">
  <mat-spinner class="spinner-center"></mat-spinner>
</mat-dialog-content>

<mat-dialog-content *ngIf="pollData" id="lifedi-modal" class="mat-typography pb-4">
  <!-- <p class="text-right">จำนวนคนโหวต {{ pollData.VOTE_COUNT }} คน</p> -->
  <p *ngIf="pollData.VOTE_COUNT === 0" class="text-center pt-4 pb-4" style="margin-bottom: 0;">
    ยังไม่มีผลโหวต
  </p>

  <div *ngIf="pollData.VOTE_COUNT > 0">
    <small class="text-right" style="width: 100%; float: right;">จำนวนคนโหวต {{ pollData.VOTE_COUNT }} คน</small>
    <canvas id="Chart" #allcanvas style="width: 200px; height: 200px;"></canvas>
  </div>
</mat-dialog-content>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>
